const CARRIER_LOGO_BASE_PATH = "/carrier-logos";

const CARRIER_LOGO_FILES = {
  AAA_COOPER: "aaa-cooper.png",
  ABF: "abf.avif",
  ARCBEST: "abf.avif",
  AVERITT: "averitt.png",
  DAYTON: "dayton-freight.png",
  ESTES: "estes.svg",
  FEDEX: "fedex.avif",
  FEDEX_FREIGHT: "fedex.avif",
  FORWARD_AIR: "forward-air.svg",
  ODFL: "olddominion.avif",
  OLD_DOMINION: "olddominion.avif",
  PITT_OHIO: "pitt-ohio.svg",
  RL_CARRIERS: "rl-carriers.svg",
  SAIA: "saia.avif",
  SEFL: "sotheast.avif",
  SOUTHEASTERN: "sotheast.avif",
  TFORCE: "tforce.avif",
  UPS: "ups.svg",
  XPO: "xpo.svg",
  YRC: "yrc.svg",
} as const;

export const CARRIER_LOGO_FILENAMES = [...new Set(Object.values(CARRIER_LOGO_FILES))] as string[];

function normalizeCarrierKey(value: string | null | undefined): string {
  return (value ?? "")
    .trim()
    .toUpperCase()
    .replace(/&/g, " AND ")
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function inferCarrierKeyFromName(name: string | null | undefined): keyof typeof CARRIER_LOGO_FILES | null {
  const normalized = normalizeCarrierKey(name);
  if (!normalized) return null;

  if (normalized.includes("AAA_COOPER")) return "AAA_COOPER";
  if (normalized.includes("ABF") || normalized.includes("ARCBEST")) return "ABF";
  if (normalized.includes("AVERITT")) return "AVERITT";
  if (normalized.includes("DAYTON")) return "DAYTON";
  if (normalized.includes("ESTES")) return "ESTES";
  if (normalized.includes("FEDEX")) return "FEDEX";
  if (normalized.includes("FORWARD_AIR")) return "FORWARD_AIR";
  if (normalized.includes("OLD_DOMINION")) return "ODFL";
  if (normalized.includes("PITT_OHIO")) return "PITT_OHIO";
  if (normalized.includes("R_L") || normalized.includes("RL_CARRIERS")) return "RL_CARRIERS";
  if (normalized.includes("SAIA")) return "SAIA";
  if (normalized.includes("SOUTHEASTERN") || normalized.includes("SEFL")) return "SEFL";
  if (normalized.includes("TFORCE") || normalized.includes("T_FORCE")) return "TFORCE";
  if (normalized.includes("UPS")) return "UPS";
  if (normalized.includes("XPO")) return "XPO";
  if (normalized.includes("YRC")) return "YRC";

  return null;
}

export function getCarrierLogoUrl(code?: string | null, name?: string | null): string | null {
  const codeKey = normalizeCarrierKey(code);
  const logoFromCode = CARRIER_LOGO_FILES[codeKey as keyof typeof CARRIER_LOGO_FILES];
  if (logoFromCode) return `${CARRIER_LOGO_BASE_PATH}/${logoFromCode}`;

  const nameKey = inferCarrierKeyFromName(name);
  const logoFromName = nameKey ? CARRIER_LOGO_FILES[nameKey] : null;
  return logoFromName ? `${CARRIER_LOGO_BASE_PATH}/${logoFromName}` : null;
}

export function getCarrierInitials(code?: string | null, name?: string | null): string {
  const source = (name || code || "Carrier").trim();
  const words = source.split(/\s+/).filter(Boolean);
  if (words.length >= 2) return `${words[0]?.[0] ?? ""}${words[1]?.[0] ?? ""}`.toUpperCase();
  return source.slice(0, 4).toUpperCase();
}
